import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { InformationBox, MuiBox, MuiGrid } from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MuiSelectNavigator } from "../../../../components/selectNavigator/MuiSelectNavigator";
import { MODULE_PERMISSIONS, PAGE_URLS } from "../../../../helpers/constants";
import { isNotEmpty } from "../../../../helpers/utils";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { programSearchSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { ProgramSearchHeaderWrapper } from "./ProgramSearchHeader.style";

export const ProgramSearchHeader: FC = () => {
  const navigate = useNavigate();
  const { fetchLabel, pageTitle } = useSiteCore();
  const { hasModulePermission } = usePermissions();

  const getLabel = (key: string) => {
    return fetchLabel(programSearchSiteCoreKeys.header, key);
  };

  let primaryNavigationOptions = [
    {
      label: getLabel(programSearchSiteCoreKeys.headerCreateProgram),
      value: 1,
    },
    ...(hasModulePermission(MODULE_PERMISSIONS.NIS_CREATE)
      ? [
          {
            label: getLabel(
              programSearchSiteCoreKeys.headerCreateNISParticipant,
            ),
            value: 2,
          },
        ]
      : []),
  ];

  const navigationOptions = [
    ...(hasModulePermission(MODULE_PERMISSIONS.BULK_CREATE)
      ? [
          {
            label: getLabel(programSearchSiteCoreKeys.bulkCreateProgramButton),
            value: 1,
          },
        ]
      : []),
    ...(hasModulePermission(MODULE_PERMISSIONS.BULK_EDIT)
      ? [
          {
            label: getLabel(programSearchSiteCoreKeys.bulkEditProgram),
            value: 2,
          },
        ]
      : []),
    ...(hasModulePermission(MODULE_PERMISSIONS.BULK_TRANSFER)
      ? [
          {
            label: getLabel(programSearchSiteCoreKeys.bulkTransferParticipants),
            value: 3,
          },
        ]
      : []),
    ...(hasModulePermission(MODULE_PERMISSIONS.BULK_INSERT)
      ? [
          {
            label: getLabel(programSearchSiteCoreKeys.bulkInsertActivity),
            value: 4,
          },
        ]
      : []),
  ];

  const handleNavigate = (flag: number) => {
    switch (flag) {
      case 1:
        navigate(PAGE_URLS.BULK_CREATE_PROGRAM, {
          state: { from: PAGE_URLS.SEARCH_PROGRAM },
        });
        break;
      case 2:
        navigate(PAGE_URLS.BULK_EDIT_PROGRAM, {
          state: { from: PAGE_URLS.SEARCH_PROGRAM },
        });
        break;
      case 3:
        navigate(PAGE_URLS.CREATE_BULK_TRANSFER);
        break;
      case 4:
        navigate(PAGE_URLS.CREATE_BULK_ACTIVITY, {
          state: { from: PAGE_URLS.SEARCH_PROGRAM },
        });
        break;
    }
  };

  const handlePrimaryNavigate = (flag: number) => {
    switch (flag) {
      case 1:
        navigate(PAGE_URLS.CREATE_PROGRAM);
        break;
      case 2:
        navigate(PAGE_URLS.CREATE_NIS_PARTICIPANT);
        break;
    }
  };

  return (
    <ProgramSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 5, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <MuiGrid size={{ sm: 7, xs: 12 }} className="header-right">
          <MuiBox className="header-right-wrapper">
            {isNotEmpty(navigationOptions) && (
              <MuiSelectNavigator
                label={getLabel(
                  programSearchSiteCoreKeys.bulkCreateProgramButton,
                )}
                options={navigationOptions}
                onNavigate={(value) => {
                  handleNavigate(value as number);
                }}
                disabled={false}
                id="page-select"
              />
            )}
            <PermissionWrapper permission={MODULE_PERMISSIONS.PROGRAM_CREATE}>
              <MuiSelectNavigator
                label={getLabel(programSearchSiteCoreKeys.headerCreateProgram)}
                options={primaryNavigationOptions}
                onNavigate={(value) => {
                  handlePrimaryNavigate(value as number);
                }}
                disabled={false}
                type="primary"
                className="header-right-button"
                id="primary-navigator"
              />
            </PermissionWrapper>
          </MuiBox>
        </MuiGrid>
      </MuiGrid>
    </ProgramSearchHeaderWrapper>
  );
};
